import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../_services/user.service';

@Component({
    template: '<div></div>',
})
export class ApiIntegrationComponent implements OnInit {
    constructor(private userService : UserService){}
    ngOnInit() {
        this.userService.getApiAcessToken();
    }
}